import { styled } from '@mui/material/styles'
import { Box, Typography, Stack, Button } from '@mui/material'

export const StyledContainer = styled(Box)(({ theme }) => ({
  margin: 0,
  width: '100%',
  backgroundColor: theme.palette.grey[50],
  minHeight: '100vh',
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(-1),
    width: 'calc(100% + 2rem)',
  },
}))

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  textAlign: 'center',
}))

export const StyledActionButtonsContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}))

export const StyledCancelButton = styled(Button)({
  flex: 1,
})
